import axios, { Method } from 'axios';

export const getIpAddress = async () => {
  try {
    const { data } = await axios.get('http://ip-api.com/json');
    return data;
  } catch (e: any) {
    console.error(e.message);
    return {};
  }
};

export const getPageURL = () => {
  return window.location.href;
};

export const getDeviceDetails = async () => {
  const type: Method = 'GET';
  const options = {
    method: type,
    url: 'https://userstack.com/ua_api.php',
    params: {
      ua: navigator.userAgent,
    },
  };
  try {
    const { data } = await axios.request(options);
    return data;
  } catch (e: any) {
    console.error(e.message);
    return {};
  }
};

export const getUserAgent = () => {
  return navigator.userAgent;
};
